import { __assign } from "tslib";
import { CounterBadge, mergeClasses } from '@fluentui/react-components';
import { useFragment } from '@nova/react';
import React from 'react';
import { useBadgeStyles } from './Badge.styles';
import { ViewMode } from './Constants';
import { useTileBadgeStyles } from './TileBadge.styles';
import { fragment as M365ApplicationBadge, } from './TileBadge.types';
/**
 * Launch Tile Badge React functional component.
 *
 */
export var TileBadge = function (_a) {
    var badgeRef = _a.badge, transparentBorder = _a.transparentBorder, readerBoxId = _a.readerBoxId, viewMode = _a.viewMode, isDragging = _a.isDragging;
    // Retrieves badge value from GQL fragment
    var badgeFragment = useFragment(M365ApplicationBadge, badgeRef);
    // render the badge
    var tileBadgeStyles = useTileBadgeStyles();
    var commonBadgeStyles = useBadgeStyles();
    var badgeStyles = __assign(__assign({}, tileBadgeStyles), commonBadgeStyles);
    var badgeElement = React.useMemo(function () {
        var badgeElement = null;
        if (badgeFragment.__typename === 'M365ApplicationNumericBadge') {
            var numericBadge = badgeFragment;
            var numericBadgeClassNames = mergeClasses(badgeStyles.badgeWide, !!transparentBorder &&
                badgeStyles.transparentBorder &&
                badgeStyles.transparentBorder, viewMode === ViewMode.Flyout && badgeStyles.flyoutBadge, viewMode === ViewMode.Default && badgeStyles.defaultBadge, isDragging && badgeStyles.draggingBadge);
            badgeElement = (React.createElement(React.Fragment, null,
                React.createElement(CounterBadge, { size: "small", shape: "circular", color: "danger", appearance: "filled", count: numericBadge.count, className: numericBadgeClassNames }),
                React.createElement("div", { className: badgeStyles.badgeReaderBox, "aria-hidden": "true", id: readerBoxId }, numericBadge.countDescription)));
        }
        else if (badgeFragment.__typename === 'M365ApplicationDotBadge') {
            var dotBadge = badgeFragment;
            var dotBadgeClassNames = mergeClasses(badgeStyles.dotBadgeCommon, !!transparentBorder &&
                badgeStyles.transparentBorder &&
                badgeStyles.transparentBorder, viewMode === ViewMode.Flyout && badgeStyles.flyoutDotBadge, viewMode === ViewMode.Default && badgeStyles.defaultDotBadge, isDragging && badgeStyles.draggingBadge);
            badgeElement = (React.createElement(React.Fragment, null,
                React.createElement(CounterBadge, { size: "small", shape: "circular", color: "danger", appearance: "filled", count: undefined, dot: true, className: dotBadgeClassNames }),
                React.createElement("div", { className: badgeStyles.badgeReaderBox, "aria-hidden": "true", id: readerBoxId }, dotBadge.description)));
        }
        return badgeElement;
    }, [
        badgeFragment,
        badgeStyles.badgeReaderBox,
        badgeStyles.badgeWide,
        badgeStyles.defaultBadge,
        badgeStyles.defaultDotBadge,
        badgeStyles.dotBadgeCommon,
        badgeStyles.draggingBadge,
        badgeStyles.flyoutBadge,
        badgeStyles.flyoutDotBadge,
        badgeStyles.transparentBorder,
        isDragging,
        readerBoxId,
        transparentBorder,
        viewMode,
    ]);
    return badgeElement;
};
//# sourceMappingURL=TileBadge.js.map